<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>STEP 6</div>
				<h2 waHeading="l" waText>Build and Run</h2>
				<p waBody="m" waColorText="quiet" waText>One command to build, one command to run.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<p waBody="m" waText>Build your project. What happens next depends on your mode.</p>
				<div *ngIf="!useGradle" class="code-block-wrapper">
					<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Terminal &mdash; Maven</div>
					<markdown [data]="mdContent_33" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<div *ngIf="useGradle" class="code-block-wrapper">
					<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Terminal &mdash; Gradle</div>
					<markdown [data]="mdContent_34" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<p waBody="m" waText>In Angular mode, the build plugin generates TypeScript, runs npm install and ng build automatically. The output is a static SPA in the build target &mdash; deploy it to any web server, CDN, or serve it locally. No JWebMP server required.</p>
				<div class="code-block-wrapper">
					<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Angular mode &mdash; serve the static SPA &#40;optional&#41;</div>
					<markdown [data]="mdContent_35" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<p waBody="m" waText>In hosted mode, the Vert.x HTTP server serves the application. Start it and open your browser.</p>
				<div class="code-block-wrapper">
					<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Hosted mode &mdash; start the server</div>
					<markdown [data]="mdContent_36" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
			</div>
		</div>
	</div>
</div>